import React, { useEffect } from 'react'
import DynamicMaster from '../../Components/DynamicMaster/DynamicMaster'
import { APICall } from '../../Helpers/APICalls/APICalls';
import { API } from '../../Axios/Axios';
import { getEmployeeDropdownUserAccess } from '../../Helpers/APIEndpoints/Endpoints';
import axios from 'axios';
import { ActionHandlerProvider } from '../../Components/ActionHandlerContext';

const UserAccessMaster = () => {

  // const getUserNames = async (e: any//, callback: any

  // ) => {
  //   // console.log(e)
  //   if (e.length >= 4) {
  //     // let requestParams = {
  //     //   searchTerm: e,
  //     // };

  //     const SearchString = e;  
  //     console.log(SearchString,'req')
  //     const requestParams = {
  //       SearchString: SearchString 
  //     };

  //     // const formData = new FormData();
  //     //  formData.append("searchTerm", e);

  //      const  data  = await API.post(getEmployeeDropdownUserAccess,
  //       JSON.stringify(requestParams)
  //     );
  //    // const response = await API.post(`{getEmployeeDropdownUserAccess}?searchTerm=${encodeURIComponent(e)}`);
      
  //      console.log('result emp dd=>',data)

  //     // if (data.Employee.length > 0) {
  //     //   let options = await data.Employee.map((custom: any) => {
  //     //     let tempObj = {
  //     //       value: custom.Id,
  //     //       label: custom.Name,
  //     //     };

  //     //     return tempObj;
  //     //   });

  //     //   await callback(options);
  //     }
  //   }

  //   useEffect(
  //     ()=>{
  //       getUserNames("test");
  //     },[])
  const interfaceActionHandler = {
    ValidateLimit:(actionType: string, form: any) => 
    {
      // let limitValue = form['limit'];
      // let secValue = form['sec'];

      // if(sec> limit)
      //validate limit code
    }
  }


  return (
   <>
        <ActionHandlerProvider
        interfaceActionHandler={interfaceActionHandler}>
          <DynamicMaster id={2} dashboardId={2} />
        </ActionHandlerProvider>
   </>
  )
}

export default UserAccessMaster
